
import { defineComponent } from "vue";



   export default defineComponent({
      props: {
         message: { type: String, required: true}
      },
      emits: ["close"],
      mounted() {
         document.getElementById("error-ok")?.focus();
      },
      methods: {
         messageLines(msg: string): string[] {
            return msg.split(/\r?\n/);
         },
      },
   });
